export const QUERY_KEYS = {
  PROFILE: 'profile',
  FOOD_TYPE: 'food-type',
  FOOD_FILE: 'food-file',
  EXERCISE_FILE: 'exercise-file',
  BLOG_CATEGORY: 'blog-category',
  PLAN: 'plans',
  PLAN_BYID: 'plan-details',
  TIER: 'tier',
  ALL_TIER: 'allTier',
  DIETARY_PREFERENCE: 'dietary-preference',
  EXERCISE_TYPE: 'exercise-types',
  GOALS: 'goals',
  COACH_CATEGORY: 'coach-category',
  COACH: 'coaches',
  COACHRATING: 'coach_rating',
  INSTANT_CONSULTATION: 'instant-consultation',
  CONSULTATIONBYID: 'consultation-details',
  COACH_BY_ID: 'coach-details',
  All_COACH: 'all-coach',
  CMS: 'cms',
  FAQ: 'faq',
  BANNER: 'banner',
  STORY: 'story',
  STORY_USER: 'storyUser',
  BLOG: 'blog',
  USER_REPORT: 'user-report',
  ABOUT_US: 'about-us',
  DIET_CHART: 'diet-chart',
  RECIPE_DETAILS: 'recipe-details',
  WORKOUT_PLAN: 'workout-plan',
  FOLLOW_UP: 'follow-up',
  USERS: 'users',
  USER_BY_ID: 'user-by-id',
  USER_ADDRESS: 'user-address',
  USER_CONSULTATION: 'user-consultation',
  GYMS: 'on-boarding-gyms',
  GYM_VERTICAL_BANNERS: 'gym-vertical-banners',
  DASHBOARD_COUNTER: 'dashboard-counter',
  DASHBOARD_CONSULTATION_STATUS: 'dashboard-consultation-status',
  DASHBOARD_COACH_KYC: 'dashboard-coach-kyc',
  DASHBOARD_PLATFORM_REGISTRATIONS: 'dashboard-platform-registrations',
  DASHBOARD_YEARLY_CONSULTATION: 'dashboard-yearly-consultation',
  DASHBOARD_RECENT_COACHES: 'dashboard-recent-coaches',
  DASHBOARD_RECENT_GYMS: 'dashboard-recent-gyms',
  DASHBOARD_RECENT_USERS: 'dashboard-recent-users',
  DASHBOARD_REVENUE_OVERVIEW: 'dashboard-revenue-overview',
  DASHBOARD_SUBSCRIPTION_PLAN_TAKEN: 'dashboard-subscription-plan-taken',
  DASHBOARD_BEST_PERFORMING_COACHES: 'dashboard-best-performing-coaches'
};
